import { ColorX } from 'framework/components/color/ColorX';
import { ArticlesInquiryLineStatusType } from 'gen/ApiClient';

export const ArticlesInquiryLineStatusToColorXRecord: Record<ArticlesInquiryLineStatusType, ColorX> = {
	Assigned: 'success',
	PartialAssigned: 'warning',
	Unassigned: 'warning',
};
